module.exports = __webpack_public_path__ + "static/assets/d8e86c2b9a41d786cc2f939c641ce386.svg";